import styled, { css } from 'styled-components';

import Button from 'components/Buttons/Button';

export const Container = styled.section`
  padding-top: 8px;

  @media ${({ theme }) => theme.device.mobile} {
    padding: 56px 24px 16px 24px;
  }
`;

export const Title = styled.h5`
  text-align: center;
  margin-bottom: 44px;
  color: ${({ theme }) => theme.expensesList.primary};
`;

const buttonCss = css`
  font-size: 16px;
  font-weight: 600;
  height: 56px;
`;

export const ImportButton = styled(Button)`
  ${buttonCss};
  margin-bottom: 16px;
`;

export const AddButton = styled(Button)`
  ${buttonCss};
`;
